module.exports = __webpack_public_path__ + "media/images/hexa5-3696c11a856ffa842e3df01c48c05be3.png";